import { render } from "./LogoutView.vue?vue&type=template&id=839c3cee"
import script from "./LogoutView.vue?vue&type=script&lang=js"
export * from "./LogoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/LogoutView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "839c3cee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('839c3cee', __exports__)) {
    api.reload('839c3cee', __exports__)
  }
  
  module.hot.accept("./LogoutView.vue?vue&type=template&id=839c3cee", () => {
    api.rerender('839c3cee', render)
  })

}


export default __exports__